import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("CUSTODIAL_FORMS");
const CRUD_ACTION_HANDLERS = getActionHandler("CUSTODIAL_FORMS");

export default function custodialForms(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
